module.exports = __webpack_public_path__ + "static/media/logo-crypto-shield-pro.0a03eefb.svg";